module.exports = __webpack_public_path__ + "build/img/advantages.6c3d993f.png";